<!-- eslint-disable prettier/prettier -->
<template>
  <div class="category">
    <!-- Попап подтверждения -->
    <ConfirmDialog
      :visible="confirmDialog.visible"
      :title="confirmDialog.title"
      :text="confirmDialog.text"
      :confirm-label="confirmDialog.confirmLabel"
      :cancel-label="confirmDialog.cancelLabel"
      @confirm="handleConfirmDialog"
      @cancel="closeConfirmDialog"
    />

    <v-row>
      <!-- Блок с пользователем -->
       <!-- {{ userID }} -->
      <EditedUser
        v-show="haveSubordinates"
        :userID="userID"
        delUser="true"
        :emptyUser="getEmpty()"
        :users="users"
        @getCurrentUser="getCurrentUserData"
        @addInterview="addInterview"
      />

      <section style="position: relative">
        <!-- Прелоадер -->
        <transition name="fade">
          <section v-if="preloader" style="position: absolute; width: 100%">
            <v-container>
              <div class="text-center">
                <v-progress-circular indeterminate />
              </div>
            </v-container>
          </section>
        </transition>

        <!-- Основной контент -->
        <transition name="fade">
          <section v-if="!preloader">
            <div class="flexBlock pd-block pl-0">
              <h3 class="custom-h3 category-title">
                <span v-if="$route.meta.title && $route.meta.title != 'Области знаний'">{{ $route.meta.title }}: </span>
                {{ header }}</h3>
            </div>

            <Breadcrumbs
              :items="breadcrumbs"
              @changeBreadcrumbsArray="changeBreadcrumbsArray"
            />
            
            <!-- Области знаний (areasLayout) -->
            <div v-if="typePage === 'areasLayout'">
              <div
                v-for="skill in skills"
                :key="skill.tag"
              >
                <div class="container-color">
                  <div class="flexBlock mb-2 mt-2">
                    <h3 class="title-area-skill">{{ skill.title }}</h3>

                    <div 
                      v-show="isAdmin"
                      class="group-btn"
                    >
                      <v-btn
                        class="customGlobalBtn emptyBtn"
                        variant="text"
                        text
                        @click="showForm(skill.tag)"
                      >
                        <i class="ti-plus" />
                        Создать сущность
                      </v-btn>
                    </div>
                  </div>

                  <Categories
                    v-if="skill.areas && skill.areas.length > 0 && !preloader"
                    :canChangeEntities="canChangeEntities"
                    :typeSkill="skill.tag"
                    type="areas"
                    :userID="userID"
                    :itemsCategory="getItems(skill.tag)"
                    :isAdmin="isAdmin"
                    @selectMark="selectMark"
                    @openEditor="openEditor"
                    @delEntity="delEntity"
                    @reloadObj="reloadObj" 
                    @saveManageAssigment="saveManageAssigment" 
                    @delFile="delFile"
                  />
                  <div v-else class="container-color">
                    <span class="empty-text">Нет доступных областей знаний</span>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Сущности (не areasLayout) -->
            <div v-if="typePage !== 'areasLayout' && typePage !== 'question'">
              <div class="col-12 container-color">
                <div class="flexBlock">
                  <h3 class="title-area-skill" />
                  <div 
                    v-show="isAdmin"
                    class="group-btn"
                  >
                    <v-btn
                      class="customGlobalBtn emptyBtn"
                      variant="text"
                      text
                      @click="showForm('entity')"
                    >
                      <i class="ti-plus" />
                      Создать сущность
                    </v-btn>
                  </div>
                </div>

                <Categories
                  v-if="childrenList && childrenList.length > 0"
                  :canChangeEntities="canChangeEntities"
                  :typeSkill="typeSkillForRole"
                  type="elements"
                  :userID="userID"
                  :itemsCategory="childrenList"
                  :isAdmin="isAdmin"
                  @selectMark="selectMark"
                  @openEditor="openEditor"
                  @delEntity="delEntity"
                  @reloadObj="reloadObj" 
                  @saveManageAssigment="saveManageAssigment" 
                  @delFile="delFile" 
                />
                <div v-else class="container-color">
                  <span class="empty-text">Нет доступных компетенций</span>
                </div>

              </div>
            </div>

            <!-- Вопросы -->
            <div v-if="showQuestionsBlock">
              <div
                v-if="(!canChangeEntities && questions.length > 0)
                  || (canChangeEntities && currentKey !== 'area' && currentKey !== 'competency')"
                class="col-12 container-color"
              >
                <div class="flexBlock">
                  <h3>Вопросы</h3>

                  <v-btn
                    v-show="isAdmin"
                    class="customGlobalBtn mb-6 emptyBtn leftBtn"
                    variant="text"
                    text
                    @click="showForm('question')"
                  >
                    <i class="ti-plus" />
                    Добавить вопрос
                  </v-btn>
                </div>

                <Categories
                  v-if="questions && questions.length > 0"
                  :canChangeEntities="canChangeEntities"
                  :userID="userID"
                  :typeSkill="typeSkillForRole"
                  :itemsCategory="questions"
                  type="questions"
                  :isAdmin="isAdmin"
                  @selectMark="selectMark"
                  @openEditor="openEditor"
                  @delEntity="delEntity"
                  @reloadObj="reloadObj" 
                  @saveManageAssigment="saveManageAssigment" 
                  @delFile="delFile"
                />
                <div v-else class="container-color">
                  <span class="empty-text">Этот раздел пуст</span>
                </div>

              </div>
            </div>

            <!-- Задания -->
            <div v-if="showQuestionsBlock">
              <div
                v-if="(!canChangeEntities && tasks.length > 0)
                  || (canChangeEntities && currentKey !== 'area' && currentKey !== 'competency')"
                class="col-12 container-color"
              >
                <div class="flexBlock">
                  <h3>Задания</h3>

                  <v-btn
                    v-show="isAdmin"
                    class="customGlobalBtn mb-6 emptyBtn leftBtn"
                    variant="text"
                    text
                    @click="showForm('task')"
                  >
                    <i class="ti-plus" />
                    Добавить задание
                  </v-btn>
                </div>
                
                <Categories
                  v-if="tasks && tasks.length > 0"
                  :canChangeEntities="canChangeEntities"
                  :typeSkill="typeSkillForRole"
                  :userID="userID"
                  :itemsCategory="tasks"
                  type="tasks"
                  :isAdmin="isAdmin"
                  @selectMark="selectMark"
                  @openEditor="openEditor"
                  @delEntity="delEntity"
                  @reloadObj="reloadObj" 
                  @saveManageAssigment="saveManageAssigment" 
                  @delFile="delFile"
                />
                <div v-else class="container-color">
                  <span class="empty-text">Этот раздел пуст</span>
                </div>

              </div>
            </div>

            <!-- Создание сущности -->
            <div v-if="creationForm && canChangeEntities" class="popup-block">
              <div class="form-popup-default">
                <v-card>
                  <v-btn
                    class="close-button"
                    title="Отменить"
                    variant="text"
                    text
                    @click="closeForm"
                  >
                    <v-icon>ti-close</v-icon>
                  </v-btn>

                  <EntityCreationForm
                    :entityType="entityType"
                    :entityKey="entityKey"
                    :header="header"
                    :skillId="skillId"
                    :taskCount="taskCount"
                    :questionCount="questionCount"
                    @saveEntity="saveNewEntity"
                    @closeForm="closeForm"
                  />
                </v-card>
              </div>
            </div>

            <!-- Редактирование сущности -->
            <div
              v-if="editForm"
              :class="{ visible: editForm }"
              class="hidden popup-block"
            >
              <div class="form-popup-default">
                <v-card>
                  <v-btn
                    class="close-button"
                    title="Отменить"
                    variant="text"
                    text
                    @click="closeEditArea"
                  >
                    <v-icon>ti-close</v-icon>
                  </v-btn>

                  <EntityEditForm
                    :data="getItem()"
                    :entityType="entityType"
                    :entityKey="entityKey"
                    :skillId="skillId"
                    @saveEditedEntity="saveEditedEntity"
                  />
                </v-card>
              </div>
            </div>

          </section>
        </transition>
      </section>

      <router-view />
    </v-row>
  </div>

</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import Categories from "@/components/Catergories/Categories";
import EntityCreationForm from "@/components/EntityCreationForm";
import EntityEditForm from "@/components/EntityEditForm";
import EditedUser from "@/components/Cards/EditedUser.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";

import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";


import GlobalRequest from "@/plugins/globalRequest";
import globalMethods from "@/plugins/globalMethods";

export default {
  name: "CategoryLayout",
  components: {
    Breadcrumbs,
    Categories,
    EntityCreationForm,
    EntityEditForm,
    EditedUser,
    ConfirmDialog
  },

  inject: ["usersStore", "openInterview"],

  data() {
    return {
      // Роутинг
      typePage: "",
      currentKey: "",
      currentPath: "",

      userID: 0,
      localUser: 0,
      canChangeEntities: false,
      typeSkillForRole: "HS",

      // Данные
      data: {},
      header: "Области знаний",

      // Состояния
      preloader: true,
      creationForm: false,
      editForm: false,

      // Текущие сущности
      item: null,
      skillId: 0,
      skillOriginId: 0,
      skillSsId: 0,
      entityType: "",
      entityKey: "",
      taskCount: 0,
      questionCount: 0,
      selectedItem: null,
      deletedItem: null,

      // Хлебные крошки
      breadcrumbs: [
        {
          text: "Области знаний",
          id: 1,
          disabled: false,
          exact: true,
          to: {
            name: "areasLayout",
            query: null
          }
        }
      ],

      // Диалог подтверждения
      confirmDialog: {
        visible: false,
        title: "Подтвердите действие",
        text: "",
        confirmLabel: "ОК",
        cancelLabel: "Отмена",
        action: null
      },

      roles: [],
      isAdmin: false,
      type: ["", "info", "success", "warning", "danger"],

      isUserInitialized: false,

    };
  },

  computed: {
    // Не задачи/не вопросы
    hasElements() {
      var hasChildren =
        this.data &&
        this.data.children &&
        Array.isArray(this.data.children);

      if (!hasChildren) {
        return false;
      }

      return this.data.children.some(function(el) {
        return el.type !== "task" && el.type !== "question";
      });
    },

    // Можно ли показывать блоки вопросов/заданий
    showQuestionsBlock() {
      var hasChildren =
        this.data &&
        this.data.children &&
        Array.isArray(this.data.children);

      return this.typePage !== "areasLayout" && (this.canChangeEntities || hasChildren);
    },

    // Список hard/soft skills
    skills() {
      var result = [];

      if (
        this.data &&
        this.data.hardSkills &&
        this.data.hardSkills.areas &&
        Array.isArray(this.data.hardSkills.areas)
      ) {
        result.push({
          title: this.data.hardSkills.title || "Hard Skills",
          tag: this.data.hardSkills.tag || "HS",
          areas: this.data.hardSkills.areas
        });
      }

      if (
        this.data &&
        this.data.softSkills &&
        this.data.softSkills.areas &&
        Array.isArray(this.data.softSkills.areas)
      ) {
        result.push({
          title: this.data.softSkills.title || "Soft Skills",
          tag: this.data.softSkills.tag || "SS",
          areas: this.data.softSkills.areas
        });
      }

      return result;
    },

    // Дети текущей сущности
    childrenList() {
      if (this.data && this.data.children && Array.isArray(this.data.children)) {
        return this.data.children;
      }
      return [];
    },

    // Отфильтрованные вопросы
    questions() {
      return this.childrenList.filter(function(item) {
        return item.type === "question";
      });
    },

    // Отфильтрованные задания
    tasks() {
      return this.childrenList.filter(function(item) {
        return item.type === "task";
      });
    },

    // Наличие подчиненных
    haveSubordinates() {
      return this.users && this.users.length;
    },

    users() {
      return this.usersStore.users;
    },

  },

  watch: {
    // Любое изменение маршрута
    async $route(to, from) {
      if (to.fullPath === from.fullPath) return;

      await this.initByRoute();
      this.updateBreadcrumbsByRoute();
    },

    // Изменение прав пользователя
    async canChangeEntities() {
      var storedUser = localStorage.getItem("current_user");
      if (storedUser) {
        this.localUser = storedUser;
      }

      await this.initByRoute();
    }
  },

  async mounted() {
    // Права и роли
    this.roles = globalMethods.getRoles();
    this.canChangeEntities = globalMethods.canChangeEntities(this.roles);

    // Есть ли у пользователя админские права
    this.isAdmin = globalMethods.isAdmin(this.roles);

    // Текущий пользователь
    var storedUser = localStorage.getItem("current_user");
    if (storedUser) {
      this.localUser = storedUser;
    }

    this.currentPath = this.$route.path;

    if(this.$route.query.userID) {
      this.userID = this.$route.query.userID;
      localStorage.setItem("selected_user", this.userID);
    } else {
      
      // console.log("00000000")
      // console.log(this.users)

      // if(this.users && this.users.length < 1) {
      //   localStorage.removeItem("selected_user");
      // }

      const stored = localStorage.getItem("selected_user");
      if (stored) {
        this.userID = Number(stored);
      } else {
        await this.initByRoute();
      }
    }

    this.isUserInitialized = true;
    this.preloader = false;
  },

  methods: {
    // Инициализация по текущему роуту
    async initByRoute() {
      this.preloader = true;

      if (this.$route.name === "areasLayout") {
        this.clearBreadcrumbsStorage();

        this.breadcrumbs = [{
          text: "Области знаний",
          disabled: true,
          to: null
        }];

      }

      var isAreasPage = this.$route.name === "areasLayout";
      var typeCurPage = this.$route.meta.type || "element";

      this.typePage = isAreasPage ? "areasLayout" : typeCurPage;
      this.currentKey = this.$route.meta && this.$route.meta.key
        ? this.$route.meta.key
        : "";
      this.entityType = this.$route.meta && this.$route.meta.type
        ? this.$route.meta.type
        : "";
      this.entityKey = this.$route.meta && this.$route.meta.key
        ? this.$route.meta.key
        : "";

      this.currentPath = this.$route.path;

      try {
        if (isAreasPage) {
          await this.loadAreas();
        } else {
          var id = this.$route.params.id;
          await this.getData(id);
        }
      } catch (e) {
        console.error("Ошибка при инициализации по маршруту:", e);
      }

      this.preloader = false;
    },

    getEmpty() {
      return !(this.userID && this.userID !== 0);
    },

    // Получение данных по id (не areasLayout)
    async getData(id) {
      if (!id) {
        console.error("ID сущности не задан");
        return;
      }

      this.preloader = true;

      var userId = this.userID || this.localUser;

      this.data = {};
      this.header = "";
      this.item = null;

      var response;
      try {
        response = await GlobalRequest.request(
          "/elements/" + id + "/" + userId,
          "GET"
        );
      } catch (e) {
        console.error("Ошибка запроса элементов:", e);
        this.preloader = false;
        return;
      }

      var result = response ? response : {};

      if (!result) {
        console.error("Пустой ответ при получении сущности");
        this.preloader = false;
        return;
      }

      this.data = result;
      this.header = result.title ? result.title : "";

      this.buildBreadcrumbs();

      this.preloader = false;
    },

    // Построение хлебных крошек
    buildBreadcrumbs() {
      const route = this.$route;
      let crumbs = [];

      // Берём сохранённые крошки
      const raw = localStorage.getItem("category_breadcrumbs");
      if (raw) {
        try {
          crumbs = JSON.parse(raw);
        } catch (e) {
          crumbs = [];
        }
      }

      // Если пусто — это первый уровень
      if (!crumbs.length) {
        crumbs.push({
          text: "Области знаний",
          type: "areasLayout",
          id: null
        });
      }

      // Проверяем: не добавлен ли уже этот уровень
      const exists = crumbs.some(c =>
        c.type === route.name &&
        String(c.id) === String(route.params.id)
      );

      if (!exists && route.name !== "areasLayout") {
        crumbs.push({
          text: route.meta.title,
          type: route.name,
          id: route.params.id
        });
      }

      // Преобразуем в формат
      this.breadcrumbs = crumbs.map((c, i) => ({
        text: c.text,
        disabled: i === crumbs.length - 1,
        to: c.type
          ? (c.id
              ? { name: c.type, params: { id: c.id }, query: route.query }
              : { name: c.type, query: route.query })
          : null
      }));

      // Сохраняем обратно
      localStorage.setItem("category_breadcrumbs", JSON.stringify(crumbs));
    },

    clearBreadcrumbsStorage() {
      localStorage.removeItem("category_breadcrumbs");
    },

    updateBreadcrumbsByRoute() {
      const route = this.$route;

      // areasLayout — сброс
      if (route.name === "areasLayout") {
        const root = [{
          text: "Области знаний",
          type: "areasLayout",
          id: null
        }];

        localStorage.setItem("category_breadcrumbs", JSON.stringify(root));

        this.breadcrumbs = [{
          text: "Области знаний",
          disabled: true,
          to: null
        }];

        return;
      }

      // Берём сохранённые крошки
      let crumbs = [];
      const raw = localStorage.getItem("category_breadcrumbs");

      if (raw) {
        try {
          crumbs = JSON.parse(raw);
        } catch (e) {
          crumbs = [];
        }
      }

      // Корень
      if (!crumbs.length) {
        crumbs.push({
          text: "Области знаний",
          type: "areasLayout",
          id: null
        });
      }

      // Текущий уровень
      const current = {
        text: route.meta.title,
        type: route.name,
        id: route.params.id || null
      };

      // Обрезаем хвост (back/forward)
      const existingIndex = crumbs.findIndex(c =>
        c.type === current.type && String(c.id) === String(current.id)
      );

      if (existingIndex !== -1) {
        crumbs = crumbs.slice(0, existingIndex + 1);
      } else {
        crumbs.push(current);
      }

      // Сохраняем
      localStorage.setItem("category_breadcrumbs", JSON.stringify(crumbs));

      this.breadcrumbs = crumbs.map((c, i) => ({
        text: c.text,
        disabled: i === crumbs.length - 1,
        to: c.type
          ? (c.id
              ? { name: c.type, params: { id: c.id }, query: route.query }
              : { name: c.type, query: route.query })
          : null
      }));
    },


    getTitleByType(type) {
      const map = {
        area: "Компетенции",
        competency: "Темы",
        theme: "Подтемы",
        subtopic: "Вопросы и задания"
      };
      return map[type] || "";
    },

    // Загрузка областей знаний (areasLayout)
    async loadAreas() {
      this.typePage = "areasLayout";
      this.header = "Области знаний";

      // isAdmin получает все скиллы или на выбранного пользователя, обычные пользователь на себя или на подчиненного

      let response = {};
      var userId = this.userID || this.localUser;

      // console.log(userId)
      
      if (userId) {
        response = await GlobalRequest.request("/root/" + userId, "GET");
        console.log(response)

        var result = response ? response : {};

        if (!result) {
          console.error("Пустой ответ при получении сущности");

          this.buildBreadcrumbs();

          this.preloader = false;

          return;
        }

        this.data = result;
      }

      // Фильтрация по typeSkill
      var typeSkill = this.$route.query.typeSkill;

      if (typeSkill === "HS" && this.data.softSkills) {
        delete this.data.softSkills;
      }
      if (typeSkill === "SS" && this.data.hardSkills) {
        delete this.data.hardSkills;
      }

      this.buildBreadcrumbs();
      this.preloader = false;
    },

    // Получить сущность для редактирования
    getItem() {
      return this.item || null;
    },

    // Получить список дочерних элементов
    getItems(type) {
      var items = [];

      if (type === "HS") {
        if (
          this.data &&
          this.data.hardSkills &&
          this.data.hardSkills.areas &&
          Array.isArray(this.data.hardSkills.areas)
        ) {
          items = this.data.hardSkills.areas;
        }
      } else if (type === "SS") {
        if (
          this.data &&
          this.data.softSkills &&
          this.data.softSkills.areas &&
          Array.isArray(this.data.softSkills.areas)
        ) {
          items = this.data.softSkills.areas;
        }
      }

      return items;
    },

    // Получение данных по пользователю (смена пользователя)
    async getCurrentUserData(id) {
      if (!id) {
        this.userID = 0;
        localStorage.removeItem("selected_user");

        const q = { ...this.$route.query };
        delete q.userID;

        this.$router.replace({ query: q });
        // return;
      }

      this.preloader = true;
      this.userID = id;

      if(!this.$route.query.userID) {
        localStorage.setItem("selected_user", id);
      }

      if (this.$route.name === "areasLayout") {
        await this.loadAreas();
      } else {
        await this.getData(this.$route.params.id);
      }

      this.preloader = false;
    },

    // Обновление breadcrumbs
    changeBreadcrumbsArray(newArr) {
      this.breadcrumbs = newArr;
    },

    // Удаление сущности
    async delEntity(item) {
      this.notifyVue('bottom', 'right', 3, "Возможность удаления сущности будет позже");
      return;

      if (!item || !item.id) {
        return;
      }

      this.deletedItem = item;

      var result;
      try {
        result = await GlobalRequest.request(
          "/element/" + item.id,
          "GET"
        );
      } catch (e) {
        console.error("Ошибка получения сущности перед удалением:", e);
        return;
      }

      var countChildren = 0;

      if (
        result &&
        result.data &&
        result.data.children &&
        Array.isArray(result.data.children)
      ) {
        countChildren = result.data.children.length;
      }

      if (countChildren > 0) {
        // Есть дочерние элементы
        this.openConfirmDialog({
          text:
            "Внутри сущности есть дочерние элементы. При подтверждении действия они будут удалены.",
          confirmLabel: "Удалить",
          action: this.confirmDeleteWithChildren
        });
      } else {
        // Обычное подтверждение удаления
        this.openConfirmDialog({
          text: "Удалить сущность?",
          confirmLabel: "Удалить",
          action: this.confirmDelete
        });
      }
    },

    // Вторая ступень подтверждения удаления
    confirmDeleteWithChildren() {
      // Закрываем первый попап и показываем второй
      this.closeConfirmDialog();

      this.openConfirmDialog({
        text: "Вы уверены?",
        confirmLabel: "Удалить",
        action: this.confirmDelete
      });
    },

    // Удаление
    async confirmDelete() {
      this.closeConfirmDialog();

      if (!this.deletedItem || !this.deletedItem.id) {
        return;
      }

      await this.deleteQuery(this.deletedItem);
    },

    async deleteQuery(item) {
      if (!item || !item.id) {
        return;
      }

      try {
        await GlobalRequest.request(
          "/element/" + item.id,
          "DELETE"
        );
      } catch (e) {
        console.error("Ошибка удаления сущности:", e);
        return;
      }

      // Обновляем данные на текущей странице
      if (this.$route.name === "areasLayout") {
        await this.loadAreas();
      } else {
        var id = this.$route.params.id;
        await this.getData(id);
      }
    },

    // Оценка сущности
    async selectMark(item) {
      if (!item || !item.id) {
        return;
      }

      this.selectedItem = item;

      if (item.type !== "task" && item.type !== "question") {
        // Для областей/тем нужно подтверждение
        this.openConfirmDialog({
          text:
            "При оценке данного уровня компетенций, для всех дочерних элементов будет проставлена выбранная оценка.",
          confirmLabel: "Оценить",
          action: this.confirmRating
        });
      } else {
        // Для задач/вопросов сразу можно оценить
        await this.itemRating(item);
      }
    },

    async confirmRating() {
      this.closeConfirmDialog();

      if (!this.selectedItem) {
        return;
      }

      await this.itemRating(this.selectedItem);
    },

    // ОЦЕНКА
    async itemRating(item) {
      var score = item.mark || 0;
      var userId = this.userID || 0;

      var body = {
        userId: userId,
        elementId: item.id,
        score: parseInt(score)
      };

      try {
        let res = await GlobalRequest.request(
          "/scores/assign",
          "POST",
          body
        );

        // Если ошибка, то выведем в уведомлении
        if(res && res.serviceAnswer && res.serviceAnswer.error) {
          console.error(res.serviceAnswer.error);
          this.notifyVue('bottom', 'right', 4, "Ошибка при выставления оценки");

          return;
        }

      } catch (e) {
        console.error("Ошибка выставления оценки:", e);
        this.notifyVue('bottom', 'right', 4, "Ошибка при выставления оценки");
        return;
      }

      if (this.$route.name === "areasLayout") { 
        await this.loadAreas();
      } else {
        var id = this.$route.params.id;
        await this.getData(id);
      }
    },

    // Создание новой сущности
    async saveNewEntity(item) {
      if (!item) {
        return;
      }

      let element;

      const parentId = this.$route.params.id || 0;

      // console.log(this.$route.meta)

      let body = {
        title: item.title,
        description: item.description,
        key: item.key,
        weight: item.weight,
        type: item.type,
        parentId: parseInt(parentId)
      };

      if (this.skillId !== 0) {
        body.skillIds = [this.skillOriginId];
      }

      const hasTaskFiles =
        item.type === "task" &&
        item.formdata instanceof FormData &&
        this.hasFilesInFormData(item.formdata);

      try {
        const fd = new FormData();

        // поля сущности
        fd.append("title", body.title);
        fd.append("description", body.description);
        fd.append("key", body.key);
        fd.append("weight", body.weight);
        fd.append("type", body.type);
        fd.append("parentId", body.parentId);

        if (body.skillIds && Array.isArray(body.skillIds) && body.skillIds.length) {
          body.skillIds.forEach((id) => {
            fd.append("skillIds[]", String(id));
          });
        }

        // файлы
        if (hasTaskFiles) {
          for (const [, value] of item.formdata.entries()) {
            if (value instanceof File) {
              fd.append("taskConditionFiles[]", value);
            }
          }
        }

        element = await GlobalRequest.request("/element/add", "POST", fd, "multipart/form-data");

        if (element && element.serviceAnswer && element.serviceAnswer.error) {
          this.notifyVue("bottom", "right", 4, element.serviceAnswer.error);
          this.creationForm = false;
          return;
        }
      } catch (e) {
        console.error("Ошибка создания сущности:", e);
        return;
      }

      this.creationForm = false;

      if (this.$route.name === "areasLayout") {
        await this.loadAreas();
      } else {
        const id = this.$route.params.id;
        await this.getData(id);
      }
    },

    // Сохранение изменений сущности
    async saveEditedEntity(newData) {
      if (!newData || !newData.id) {
        return;
      }

      var element;

      const parentId = this.$route.params.id || 0;

      let body = {
        title: newData.title ? newData.title : "",
        description: newData.description ? newData.description : "",
        key: newData.key,
        weight: newData.weight,
        type: newData.type,
        parentId: parseInt(parentId)
      };

      const hasTaskFiles =
        newData.type === "task" &&
        newData.formdata instanceof FormData &&
        this.hasFilesInFormData(newData.formdata);

      try {
        const fd = new FormData();

        // поля сущности
        fd.append("title", body.title);
        fd.append("description", body.description);
        fd.append("key", body.key);
        fd.append("weight", body.weight);
        fd.append("type", body.type);
        fd.append("parentId", body.parentId);

        if (hasTaskFiles) {
          for (const [, value] of newData.formdata.entries()) {
            if (value instanceof File) {
              fd.append("taskConditionFiles[]", value);
            }
          }
        }

        element = await GlobalRequest.request(
          "/element/update/" + newData.id,
          "POST",
          fd,
          "multipart/form-data"
        );

        // Если ошибка, то выведем в уведомлении
        if(element && element.serviceAnswer && element.serviceAnswer.error) {
          this.notifyVue('bottom', 'right', 4, element.serviceAnswer.error);
          this.editForm = false;
          return;
        }

      } catch (e) {
        console.error("Ошибка обновления сущности:", e);
        return;
      }

      this.editForm = false;

      if (this.$route.name === "areasLayout") {
        await this.loadAreas();
      } else {
        var id = this.$route.params.id;
        await this.getData(id);
      }
    },

    hasFilesInFormData(fd) {
      if (!(fd instanceof FormData)) return false;

      for (const [, value] of fd.entries()) {
        if (value instanceof File) return true;
        if (value instanceof Blob) return true;
      }

      return false;
    },

    // Показ формы создания
    async showForm(type) {
      if (type === "HS" || type === "SS") {
        // Создание областей для типа скилла
        var areas = [];
        let result = null;

        if (type === "HS") {
          if (
            this.data &&
            this.data.hardSkills &&
            this.data.hardSkills.areas &&
            Array.isArray(this.data.hardSkills.areas)
          ) {
            areas = this.data.hardSkills.areas;
          }
          this.skillId = 1;

          // Получаем id Скилла
          result = await GlobalRequest.request("/skill/hs", "GET");
          

        } else {
          if (
            this.data &&
            this.data.softSkills &&
            this.data.softSkills.areas &&
            Array.isArray(this.data.softSkills.areas)
          ) {
            areas = this.data.softSkills.areas;
          }
          this.skillId = 2;

          // Получаем id Скилла
          result = await GlobalRequest.request("/skill/ss", "GET");
        }

        if (result && typeof result === 'number') {
          this.skillOriginId = result;
        }

        this.entityType = "area";
        this.entityKey = "aName";
      } else {
        // Создание дочерней сущности
        this.skillId = 0;

        this.entityType =
          this.$route.meta && this.$route.meta.type
            ? this.$route.meta.type
            : "entity";

        this.entityKey =
          this.$route.meta && this.$route.meta.key
            ? this.$route.meta.key
            : "entityName";

        if (type === "task") {
          this.entityType = "task";
          this.entityKey = "taskName";
        } else if (type === "question") {
          this.entityType = "question";
          this.entityKey = "qName";
        } 

      }

      this.creationForm = true;
    },

    // Управление формами
    closeForm() {
      this.creationForm = false;
      this.closeConfirmDialog();
    },

    closeEditArea() {
      this.editForm = false;
    },

    openEditor(item) {
      this.editForm = true;
      
      this.item = item || null;
    },

    // Попап
    openConfirmDialog(config) {
      this.confirmDialog.visible = true;
      this.confirmDialog.title = config.title || "Подтвердите действие";
      this.confirmDialog.text = config.text || "";
      this.confirmDialog.confirmLabel = config.confirmLabel || "ОК";
      this.confirmDialog.cancelLabel = config.cancelLabel || "Отмена";
      this.confirmDialog.action = config.action || null;
    },

    closeConfirmDialog() {
      this.confirmDialog.visible = false;
      this.confirmDialog.text = "";
      this.confirmDialog.action = null;
    },

    handleConfirmDialog() {
      if (this.confirmDialog.action) {
        // Функция
        this.confirmDialog.action();
      }
    },

    // Ошибки
    errors(text) {
      alert(text);
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color],
        message: text,
      });
    },

    // Назначение интервью
    addInterview(id) {
      this.openInterview(id);
    },

    getDate() {
      // 2023-10-26T18:32
      let date= new Date();
      let day = "0" + date.getDate();
      let month = "0" + (date.getMonth()+1);
      let year = date.getFullYear();
      let hours = "0" + date.getHours();
      let minutes = "0" + date.getMinutes();
      let seconds = "0" + date.getSeconds();

      return year + "-" + month.substr(-2) + "-" + day.substr(-2) + "T" + hours.substr(-2) + ':' + minutes.substr(-2);
    },

    async reloadObj(res) {
      if (this.$route.name === "areasLayout") {
        await this.loadAreas();
      } else {
        var id = this.$route.params.id;
        await this.getData(id);
      }
    },

    async saveManageAssigment(res) {

      // console.log(res)
      // console.log(this.data.children.find(item => item.id == res.elementId))

      // изменить текущий элемент или обновить древо
      if(this.data && this.data.children && res.elementId && res.targetRights) {
        let editedChild = this.data.children.find(item => item.id == res.elementId)
        editedChild.targetRights = res.targetRights;
      } 
      // else {
      //   if (this.$route.name === "areasLayout") {
      //     await this.loadAreas();
      //   } else {
      //     var id = this.$route.params.id;
      //     await this.getData(id);
      //   }
      // }
    },

    delFile(payload) {
      console.log(payload)
      this.openConfirmDialog({
        text:
          "Удалить файл?",
        confirmLabel: "Удалить",
        action: () => this.confirmDelFile(payload)
      });
    },

    async confirmDelFile(payload) {

      const { fileId, attachmentType, onSuccess } = payload || {};
      if (!fileId) return;

      const endpointByType = {
        condition: "/task/delete/condition-file/",
        candidate: "/task/delete/candidate-file/",
      };

      const endpoint = endpointByType[attachmentType];
      if (!endpoint) {
        this.closeConfirmDialog();
        return;
      }

      try {
       const res = await GlobalRequest.request(endpoint + fileId, "DELETE");

        if(res && res.success) {
          // обновить данные
          if (typeof onSuccess === "function") onSuccess();
        } else {
          this.notifyVue('bottom', 'right', 4, "Ошибка удаления файла");
        }
      } catch (e) {
        console.error("Ошибка удаления файла задания:", e);
        this.notifyVue('bottom', 'right', 4, "Ошибка удаления файла");
      }

      this.closeConfirmDialog();
    },

  }
};
</script>

<style scoped>
.title-area-skill {
  display: flex;
  align-items: center;
}
.empty-text {
  font-family: "Montserrat", sans-serif;
  color: #89929d;
  font-size: 14px;
}
</style>
